export function safeParseContent(content: any): any {
  if (!content) return {};
  
  if (typeof content === 'object' && !Array.isArray(content)) {
    return content;
  }
  
  if (typeof content === 'string') {
    try {
      return JSON.parse(content);
    } catch (e) {
      console.error('Erreur parsing content:', e);
      return {};
    }
  }
  
  return {};
}